import { render, staticRenderFns } from "./HasArmoredDoor.vue?vue&type=template&id=4b5d4a80&"
import script from "./HasArmoredDoor.vue?vue&type=script&lang=ts&"
export * from "./HasArmoredDoor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports